import React from "react";

import { Database } from "components/Common/clearsense-ui/icons";

const getFields = ({ properties, required }) => {
  const keys = Object.keys(properties);
  const fields = Object.values(properties).map((specification, index) => ({
    ...specification,
    key: keys[index],
    type: specification.airbyte_secret ? "password" : specification.type,
    required: required?.includes(keys[index]),
  }));
  fields.sort((a, b) => a.order - b.order);
  return fields;
};

const formatBytes = bytes => {
  if (!bytes) return "0 Bytes";

  const quotient = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const divisor = Math.floor(Math.log(bytes) / Math.log(quotient));

  return `${parseFloat((bytes / Math.pow(quotient, divisor)).toFixed(2))} ${
    sizes[divisor]
  }`;
};

const dataCy = name => `${name.replaceAll("_", "-")}`;

const snakeCaseToTitleCase = string => {
  const words = string.split("_");
  const capitalizedWords = words.map(
    word => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedWords.join(" ");
};

const getIcon = icon => {
  const isIconPresent = icon !== null;
  return isIconPresent ? (
    <img
      alt=""
      src={`data:image/svg+xml;utf8,${encodeURIComponent(icon)}`}
      className="self-center w-5 h-5"
    ></img>
  ) : (
    <Database />
  );
};

export { getFields, formatBytes, dataCy, getIcon, snakeCaseToTitleCase };
